export const locale = {
    'AttributionControl.ToggleAttribution': 'Quellenangaben ein-/ausblenden',
    'AttributionControl.MapFeedback': 'Feedback zur Karte',
    'FullscreenControl.Enter': 'Vollbild aktivieren',
    'FullscreenControl.Exit': 'Vollbild beenden',
    'GeolocateControl.FindMyLocation': 'Meinen Standort anzeigen',
    'GeolocateControl.LocationNotAvailable': 'Standort nicht verfügbar',
    'LogoControl.Title': 'Mapbox-Logo',
    'Map.Title': 'Karte',
    'NavigationControl.ResetBearing': 'Ausrichtung nach Norden zurücksetzen',
    'NavigationControl.ZoomIn': 'Vergrößern',
    'NavigationControl.ZoomOut': 'Verkleinern',
    'ScaleControl.Feet': 'ft',
    'ScaleControl.Meters': 'm',
    'ScaleControl.Kilometers': 'km',
    'ScaleControl.Miles': 'mi',
    'ScaleControl.NauticalMiles': 'sm',
    'ScrollZoomBlocker.CtrlMessage': 'Verwenden Sie Strg + Scrollen zum Zoomen',
    'ScrollZoomBlocker.CmdMessage': 'Verwenden Sie ⌘ + Scrollen zum Zoomen',
    'TouchPanBlocker.Message': 'Verwenden Sie zwei Finger zum Verschieben der Karte',
};
